import React, { useState, useEffect } from 'react'
import { Query } from '../../api'
import { useQuery } from '@apollo/react-hooks'
import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog'
import { useTranslation } from 'react-i18next'
import { CheckSquare } from 'lucide-react'
import FileGrid from './grid'

const FileSelector = ({ directory, onSelected, files }) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const [selected, setSelected] = useState([])
  const { data, loading } = useQuery(Query.FILES, { variables: { directory } })

  const handleSubmit = () => {
    onSelected(selected)
    setOpen(false)
  }

  useEffect(() => setSelected(files.map((f) => f.id)), [files])

  return (
    <>
      <Button size="sm" variant="outline" onClick={() => setOpen(true)}>
        <CheckSquare className="h-4 w-4" />
        {t('FileManager_manage_documents_btn')}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-3xl">
          <DialogHeader>
            <DialogTitle>{t('FileManager_file_selector_select_file')}</DialogTitle>
          </DialogHeader>
          <FileGrid
            actionBar={true}
            onSelectionChange={setSelected}
            selection={selected}
            rows={data ? data.files : []}
          />
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>
              {t('Common_cancel')}
            </Button>
            <Button onClick={handleSubmit}>
              {t('FileManager_file_selector_select_files_btn')}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default FileSelector
